// extracted by mini-css-extract-plugin
export default {"container":"previous-meetings-widget_view_container__+Nt9T","title":"previous-meetings-widget_view_title__VDCN7"};